import LZString from "lz-string";
import { createParam } from "solito";

import type { CaseType } from "@medbillai/schemas";
import { CASE_PREVIEW_ID } from "@medbillai/utils/urls";

import type { PreviewEventWithMetadata } from "../utils/types";

type Params = {
  id: string;
  // Technically should be a boolean, but Solito gives us a string regardless.
  unread?: string;
  firstMessage?: string | undefined;
  title?: string;
  caseType?: CaseType;
  storeKey?: string;
  skipPageUILoad?: boolean;
  // Should only be passed if the CASE_SCREEN_REFACTOR flag is on
  config?: string;
};

const { useParams } = createParam<Params>();

export const useCaseScreenParams = () => {
  const { params, setParams } = useParams();
  return {
    params: {
      ...params,
      unread: params.unread === "true",
      config: params.config ? decodePreviewConfig(params.config) : undefined,
    },
    setParams,
  };
};

export const useIsPreviewCase = () => {
  const { params } = useCaseScreenParams();
  return params.id === CASE_PREVIEW_ID;
};

export type PreviewConfig = {
  id: string;
  caseType: CaseType;
  title: string;
  events: PreviewEventWithMetadata[];
};

export const encodePreviewConfig = (config: PreviewConfig) => {
  return LZString.compressToEncodedURIComponent(JSON.stringify(config));
};

export const decodePreviewConfig = (encoded: string) => {
  try {
    return JSON.parse(
      LZString.decompressFromEncodedURIComponent(encoded),
    ) as PreviewConfig;
  } catch {
    return null;
  }
};
